<!-- CLICK droit désactivé (relou pour bosser) -->
<!-- (contextmenu)="$event.preventDefault(); onRightClick()" -->
<span class="noeud-content" (click)="onSelected()" (keydown.enter)="onSelected()" tabindex="0" [class.admin]="hasPIAActifInChildren">
    @if (objetMaquette.classe !== 'O') {
    <span class="type-border" [ngClass]="objetMaquette.classe">{{ objetMaquette.classe }}</span>
    } @if (objetMaquette.classe === 'O') {
    <span class="type-border" [ngClass]="objetMaquette.classe">{{ objetMaquette.type }}</span>
    }
    {{ objetMaquette.code }}
    {{ objetMaquette.libelle }}
</span>

<div class="right-content">
    <div class="zone-ordre">
        @if (modeOrdre() && reordonnable()) {
        <ng-container *appShowIfAutorise="ODF_ORDONNER_ENFANT">
            @if ({ contexteValide: hasSomeContextValidated() | async, estSuperGestionnaire: isSuperGestionnaire$ | async }; as
            etatReordonnancement) {
            <button
                type="button"
                class="bouton-reordonnancement"
                mat-icon-button
                cdkDragHandle
                [attr.data-tfa]="'bouton-reordonnancement_' + objetMaquette.code"
                [disabled]="
                    isControleDeReordonnancementDesactive(etatReordonnancement.contexteValide, etatReordonnancement.estSuperGestionnaire)
                "
                [matTooltip]="
                    getToolTipControleDeReordonnancement(etatReordonnancement.contexteValide, etatReordonnancement.estSuperGestionnaire)
                "
                (click)="$event.stopPropagation()"
            >
                <mat-icon [attr.data-tfa]="'icone-reordonnancement_' + objetMaquette.code">drag_indicator</mat-icon>
            </button>
            }
        </ng-container>
        }
    </div>
    @if (objetMaquette.ects) {
    <div class="ects" [matTooltip]="objetMaquette.ects + ' crédits ECTS'">
        {{ objetMaquette.ects }}
    </div>
    } @if (!objetMaquette.estEnfantDeGroupement && objetMaquette.level !== 0) {
    <div class="obligatoire-facultatif" [matTooltip]="objetMaquette.obligatoire ? 'Obligatoire' : 'Facultatif'">
        {{ objetMaquette.obligatoire ? 'O' : 'F' }}
    </div>
    } @if (objetMaquette.mutualise) {
    <mat-icon class="mutualise" aria-hidden="false" data-tfa="icone-mutualise" color="accent" matTooltip="Objet mutualisé">share</mat-icon>
    } @if (objetMaquette.pia; as pia) { @if (pia.actif) {
    <mat-icon
        color="accent"
        [matTooltip]="'Point d\'inscription administrative'"
        [attr.data-tfa]="'icone-point-IA_' + objetMaquette.code"
        class="point-IA actif"
        aria-hidden="false"
        aria-label="Point d'inscription administrative"
        >person_pin</mat-icon
    >
    } @if (!pia.actif) {
    <mat-icon
        color="primary"
        matTooltip="Point d'inscription administrative inactif"
        [attr.data-tfa]="'icone-point-IA_' + objetMaquette.code"
        class="point-IA inactif"
        aria-hidden
        >group_off</mat-icon
    >
    } } @if (objetMaquette.valide) {
    <mat-icon color="accent" [attr.data-tfa]="'icone-valide' + objetMaquette.code" class="valide" matTooltip="Validé" aria-hidden="false"
        >check</mat-icon
    >
    }
    <button
        [attr.data-tfa]="'bouton-actions_' + objetMaquette.code"
        class="menu-button"
        mat-icon-button
        #menuTrigger
        matTooltip="actions sur l'objet"
        [matMenuTriggerFor]="menu"
        [matMenuTriggerData]="{ objetMaquette: objetMaquette }"
        (click)="$event.stopImmediatePropagation(); onSelected()"
    >
        <mat-icon class="icone-more" data-tfa="icone_more">more_horiz</mat-icon>
    </button>
</div>

<mat-menu data-tfa="menu-actions" #menu="matMenu">
    <ng-template matMenuContent let-objetMaquette="objetMaquette">
        <button
            data-tfa="bouton-menu_ajouter-enfant"
            *appShowIfAutorise="ODF_AJOUTER_ENFANT"
            mat-menu-item
            [matMenuTriggerFor]="ajouterEnfantMenu"
        >
            Ajouter un enfant
        </button>
        @if (!objetMaquette.racine) {
        <button
            data-tfa="bouton-menu_détacher"
            mat-menu-item
            *appShowIfAutorise="ODF_RETIRER_ENFANT"
            [disabled]="objetMaquette.valide && (hasSomeContextValidated() | async) !== false"
            [matTooltip]="
                objetMaquette.valide && (hasSomeContextValidated() | async) === true
                    ? 'Impossible détacher l\'enfant ' +
                      objetMaquette.libelle +
                      '  de l\'objet maquette car un des chemins les contenant est validé'
                    : 'Détacher'
            "
            (click)="onDetacher()"
        >
            Détacher
        </button>
        } @if (afficherActionsReordonnancement || afficherActionModifierOrdreEnfants) {
        <button
            data-tfa="bouton-menu_ordonnancement"
            mat-menu-item
            *appShowIfAutorise="ODF_ORDONNER_ENFANT"
            [matMenuTriggerFor]="ordonnancementMenu"
        >
            Ordonnancement
        </button>
        } @if ({ contexteValide: hasSomeContextValidated() | async, estSuperGestionnaire: isSuperGestionnaire$ | async }; as etatLienEnfant)
        { @if (!objetMaquette.racine && !objetMaquette.obligatoire && !objetMaquette.estEnfantDeGroupement) {
        <button
            data-tfa="bouton-menu_rendre_obligatoire"
            mat-menu-item
            *appShowIfAutorise="ODF_MODIFIER_LIEN_ENFANT"
            [disabled]="isModificationLienEnfantDesactive(etatLienEnfant.contexteValide, etatLienEnfant.estSuperGestionnaire)"
            [matTooltip]="
                getToolTipModificationLienEnfant(etatLienEnfant.contexteValide, etatLienEnfant.estSuperGestionnaire, 'Rendre obligatoire')
            "
            (click)="onRendreObligatoire()"
        >
            Rendre obligatoire
        </button>
        } @if (!objetMaquette.racine && objetMaquette.obligatoire && !objetMaquette.estEnfantDeGroupement) {
        <button
            data-tfa="bouton-menu_rendre_facultatif"
            mat-menu-item
            *appShowIfAutorise="ODF_MODIFIER_LIEN_ENFANT"
            [disabled]="isModificationLienEnfantDesactive(etatLienEnfant.contexteValide, etatLienEnfant.estSuperGestionnaire)"
            [matTooltip]="
                getToolTipModificationLienEnfant(etatLienEnfant.contexteValide, etatLienEnfant.estSuperGestionnaire, 'Rendre facultatif')
            "
            (click)="onRendreFacultatif()"
        >
            Rendre facultatif
        </button>
        } } @if (canAddPIA) {
        <button
            data-tfa="bouton-menu_ajout_PIA"
            *appShowIfAutorise="ODF_DECLARER_POINT_INSCRIPTION_ADMINISTRATIVE"
            mat-menu-item
            (click)="onAjouterPIA()"
        >
            Ajouter un point d'inscription administrative
        </button>
        } @if (canRemovePIA) {
        <button
            data-tfa="bouton-menu_retrait_PIA"
            *appShowIfAutorise="ODF_RETIRER_POINT_INSCRIPTION_ADMINISTRATIVE"
            mat-menu-item
            (click)="onAjouterPIA()"
        >
            Retirer le point d'inscription administrative
        </button>
        } @if (canAddPIAAsSupergestionnaire) {
        <button
            data-tfa="bouton-menu_ajout_PIA_supergestionnaire"
            *appShowIfAutorise="ODF_SUPERGESTIONNAIRE"
            matTooltip="Ajouter un point d'inscription administrative sur une branche validée"
            mat-menu-item
            (click)="onAjouterPIA()"
        >
            Ajouter un point d'inscription administrative
        </button>
        } @if (objetMaquette.valide && objetMaquette.pia) { @if (objetMaquette.pia?.actif) {
        <button
            data-tfa="bouton-inactiver-PIA"
            mat-menu-item
            *appShowIfAutorise="ODF_DESACTIVER_POINT_INSCRIPTION_ADMINISTRATIVE"
            matTooltip="inactiver le caractère PIA de cet objet sur ce chemin"
            (click)="inactiverPia()"
        >
            Inactiver le caractère PIA de l'objet
        </button>
        } @else {
        <button
            data-tfa="bouton-reactiver-PIA"
            mat-menu-item
            *appShowIfAutorise="ODF_REACTIVER_POINT_INSCRIPTION_ADMINISTRATIVE"
            matTooltip="permet de réactiver le caractère PIA d'un objet qui a été désactivé."
            (click)="reactiverPia()"
        >
            Réactiver le caractère PIA de l'objet
        </button>
        } } @if (!isSandBox) { @if (canTogglePartieAdmin) {
        <button
            data-tfa="bouton-menu_Valider-admin"
            mat-menu-item
            (click)="validerAdministrativement()"
            *appShowIfAutorise="ODF_VALIDER_PARTIE_HAUTE"
            [disabled]="atLeastOneChildIsValidated"
        >
            Valider la partie administrative
        </button>
        } @if (canValidatePartiePedagogique) {
        <button
            data-tfa="bouton-menu_Valider-péda"
            *appShowIfAutorise="ODF_VALIDER_PARTIE_BASSE"
            [disabled]="!objetMaquette.piaPresentSurUnAncetre?.piaActif"
            [matTooltip]="!objetMaquette.piaPresentSurUnAncetre?.piaActif ? 'Le point d\'inscription administrative n\'est pas validé' : ''"
            mat-menu-item
            (click)="validerPedagogiquement()"
        >
            Valider la partie pédagogique
        </button>
        } }
        <button
            data-tfa="bouton-menu_supprimer"
            mat-menu-item
            [disabled]="objetMaquette.valide"
            [matTooltipDisabled]="!objetMaquette.valide"
            *appShowIfAutorise="ODF_SUPPRIMER_OBJET_MAQUETTE"
            [matTooltip]="'L\'objet est validé et ne peut donc pas être supprimé.'"
            (click)="onSupprimer(objetMaquette)"
        >
            Supprimer
        </button>
        <button data-tfa="bouton-menu_ouvrir-tout-ce-niveau" mat-menu-item (click)="onExpandAllNodesOfSameDepth()">
            Ouvrir tous les éléments du même niveau
        </button>
        <button data-tfa="bouton-menu_copier-lien" mat-menu-item (click)="copyLinkToClipboard()">
            Copier le lien vers cet objet
        </button>
    </ng-template>
</mat-menu>

<mat-menu data-tfa="menu-ajouter-enfant" #ajouterEnfantMenu="matMenu">
    <button data-tfa="bouton-menu-ajouter-enfant_nouveau" mat-menu-item (click)="selectParentPourAjoutEnfant(false)">
        Nouvel objet maquette
    </button>
    <button data-tfa="bouton-menu-ajouter-enfant_existant" mat-menu-item (click)="selectParentPourAjoutEnfant(true)">
        Objet maquette existant
    </button>
</mat-menu>

<mat-menu data-tfa="menu-ordonnancement" #ordonnancementMenu="matMenu">
    @if (afficherActionsReordonnancement || afficherActionModifierOrdreEnfants) { @if ({ contexteValide: hasSomeContextValidated() | async,
    estSuperGestionnaire: isSuperGestionnaire$ | async }; as etatOrdonnancement) { @if (afficherActionModifierOrdreEnfants) {
    <button
        data-tfa="bouton-menu_reordonner-enfants"
        mat-menu-item
        *appShowIfAutorise="ODF_ORDONNER_ENFANT"
        [disabled]="isActionModifierOrdreEnfantsDesactive(etatOrdonnancement.contexteValide, etatOrdonnancement.estSuperGestionnaire)"
        [matTooltip]="getToolTipModifierOrdreEnfants(etatOrdonnancement.contexteValide, etatOrdonnancement.estSuperGestionnaire)"
        (click)="onModifierOrdreDesEnfants()"
    >
        {{ parentReordonne ? 'Quitter le réordonnancement' : 'Réordonner les enfants' }}
    </button>
    } @if (afficherActionsReordonnancement) {
    <button
        data-tfa="bouton-menu_placer-au-debut"
        mat-menu-item
        *appShowIfAutorise="ODF_ORDONNER_ENFANT"
        [disabled]="
            ordonnancementEnCours() ||
            !peutPlacerAuDebut() ||
            isModificationLienEnfantDesactive(etatOrdonnancement.contexteValide, etatOrdonnancement.estSuperGestionnaire)
        "
        [matTooltip]="
            getToolTipModificationLienEnfant(
                etatOrdonnancement.contexteValide,
                etatOrdonnancement.estSuperGestionnaire,
                peutPlacerAuDebut() ? 'Placer cet enfant au début' : 'Cet enfant est déjà en première position'
            )
        "
        (click)="onPlacerEnfantAuDebut()"
    >
        Placer au début
    </button>
    <button
        data-tfa="bouton-menu_monter"
        mat-menu-item
        *appShowIfAutorise="ODF_ORDONNER_ENFANT"
        [disabled]="
            ordonnancementEnCours() ||
            !peutMonter() ||
            isModificationLienEnfantDesactive(etatOrdonnancement.contexteValide, etatOrdonnancement.estSuperGestionnaire)
        "
        [matTooltip]="
            getToolTipModificationLienEnfant(
                etatOrdonnancement.contexteValide,
                etatOrdonnancement.estSuperGestionnaire,
                peutMonter() ? 'Déplacer cet enfant au-dessus' : 'Cet enfant est déjà en première position'
            )
        "
        (click)="onMonterEnfant()"
    >
        <mat-icon data-tfa="icone-menu_monter">keyboard_arrow_up</mat-icon>
        Déplacer au-dessus
    </button>
    <button
        data-tfa="bouton-menu_descendre"
        mat-menu-item
        *appShowIfAutorise="ODF_ORDONNER_ENFANT"
        [disabled]="
            ordonnancementEnCours() ||
            !peutDescendre() ||
            isModificationLienEnfantDesactive(etatOrdonnancement.contexteValide, etatOrdonnancement.estSuperGestionnaire)
        "
        [matTooltip]="
            getToolTipModificationLienEnfant(
                etatOrdonnancement.contexteValide,
                etatOrdonnancement.estSuperGestionnaire,
                peutDescendre() ? 'Déplacer cet enfant en dessous' : 'Cet enfant est déjà en dernière position'
            )
        "
        (click)="onDescendreEnfant()"
    >
        <mat-icon data-tfa="icone-menu_descendre">keyboard_arrow_down</mat-icon>
        Déplacer en dessous
    </button>
    <button
        data-tfa="bouton-menu_placer-a-la-fin"
        mat-menu-item
        *appShowIfAutorise="ODF_ORDONNER_ENFANT"
        [disabled]="
            ordonnancementEnCours() ||
            !peutPlacerALaFin() ||
            isModificationLienEnfantDesactive(etatOrdonnancement.contexteValide, etatOrdonnancement.estSuperGestionnaire)
        "
        [matTooltip]="
            getToolTipModificationLienEnfant(
                etatOrdonnancement.contexteValide,
                etatOrdonnancement.estSuperGestionnaire,
                peutPlacerALaFin() ? 'Placer cet enfant à la fin' : 'Cet enfant est déjà en dernière position'
            )
        "
        (click)="onPlacerEnfantALaFin()"
    >
        Placer à la fin
    </button>
    } } }
</mat-menu>
